import { matchesInsuranceList } from "@/src/lib/special-cases/evaluate-special-cases";

/**
 * Payers ops wants visually flagged on the sync-instructions Insurance step — these plans have
 * special-case handling ops needs to remember, distinct from the referral/authorization
 * requirements already driven by insurance-grid.ts. PIMC also appears as a named payer in
 * insurance-grid.json's case-policy rows; both the acronym and full name are listed here because
 * the full name doesn't contain "PIMC". The match is a normalized substring, so a short name that
 * the full name contains (River People) needs only the one entry.
 */
export const TPR_SPECIAL_CASE_INSURANCE_PAYERS: readonly string[] = [
  "PIMC",
  "Phoenix Indian Medical Center",
  "River People",
  "Triwest",
  "MercyCare",
];

export function isTprSpecialCaseInsurance(payerName: string | null | undefined): boolean {
  const trimmed = payerName?.trim();

  if (!trimmed) return false;

  return matchesInsuranceList(trimmed, [...TPR_SPECIAL_CASE_INSURANCE_PAYERS]);
}
